import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { notify, notifyError } from "../../../utils/toast";
import BackArrow from "../../../components/common/back-arrow";
import FadeInWrapper from "../../../components/common/fade-in-wrapper";
import { gql, useMutation } from "@apollo/client";
import { useAuth } from "../../../core/auth";

const MANAGER_LOGIN = gql`
  mutation ManagerLogin($contactNumber: String!, $password: String!) {
    managerLogin(contactNumber: $contactNumber, password: $password) {
      token
      error
    }
  }
`;

const ManagerLogin = () => {
  const { loginManager, changeLastPage } = useAuth();
  const navigate = useNavigate();
  const [phone, setPhone] = useState("");
  const [password, setPassword] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [login] = useMutation(MANAGER_LOGIN);

  const handleLogin = async () => {
    if (!phone || !password) {
      notifyError("휴대폰 번호와 비밀번호를 모두 입력해주세요.");
      return;
    }

    setIsSubmitting(true);

    const response = await login({
      variables: { contactNumber: phone, password },
    });

    const { token, error } = response.data.managerLogin;

    if (error) {
      notifyError(error);
      setIsSubmitting(false);
      return;
    }

    localStorage.setItem("managerToken", token);

    await loginManager();
    changeLastPage();
    navigate("/manager/home");
    notify("로그인 성공!");
    setIsSubmitting(false);
  };

  const handleKeyPress = (e: React.KeyboardEvent) => {
    if (e.key === "Enter") {
      handleLogin();
    }
  };

  return (
    <div className="flex items-center justify-center min-h-screen p-4">
      <FadeInWrapper className="w-full max-w-md bg-white p-6 pb-10">
        <div className="mb-4" onClick={() => navigate(-1)}>
          <BackArrow />
        </div>

        <h2 className="text-2xl font-semibold text-center text-black mb-6">
          안녕하세요 매니저님
        </h2>
        <div className="text-center text-gray-600 mb-8 p-4 bg-gray-100 rounded-xl break-keep">
          <p className="mb-2">
            이곳은 여러 가게를 운영하는 사장님(매니저)을 위한 기능입니다.
          </p>
          <p className="text-md text-blue-500">
            매니저 계정 생성을 원하는 경우,
            <br /> 카카오 채널로 문의주세요.
          </p>
        </div>

        <div className="space-y-4">
          <div>
            <label
              htmlFor="phone"
              className="block text-sm font-medium text-black mb-2 pl-2"
            >
              휴대폰 번호
            </label>
            <input
              type="tel"
              id="email"
              value={phone}
              onChange={(e) => setPhone(e.target.value)}
              onKeyPress={handleKeyPress}
              required
              className="w-full px-4 py-4 border border-gray-300 rounded-xl focus:outline-none focus:border-[#1562fc]"
              placeholder="휴대폰 번호를 입력하세요."
            />
          </div>

          <div>
            <label
              htmlFor="password"
              className="block text-sm font-medium text-black mb-2 pl-2"
            >
              비밀번호
            </label>
            <input
              type="password"
              id="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              onKeyPress={handleKeyPress}
              required
              className="w-full px-4 py-4 border border-gray-300 rounded-xl focus:outline-none focus:border-[#1562fc]"
              placeholder="비밀번호를 입력하세요."
            />
          </div>

          <button
            type="button"
            onClick={handleLogin}
            className={`w-full py-3 mt-6 rounded-xl text-white font-bold ${
              isSubmitting
                ? "bg-gray-400 cursor-not-allowed"
                : "bg-[#1562fc] hover:bg-[#124ab7] transition duration-150"
            }`}
            disabled={isSubmitting}
          >
            {isSubmitting ? "로그인 중..." : "로그인"}
          </button>

          <div className="text-center mt-6">
            <button
              type="button"
              onClick={() => {
                window.open("http://pf.kakao.com/_xawxcRn/chat", "_blank");
              }}
              className="text-sm text-gray-600 hover:text-[#1562fc] transition duration-150 underline"
            >
              계정이 필요하신가요? 문의하기
            </button>
          </div>
        </div>
      </FadeInWrapper>
    </div>
  );
};

export default ManagerLogin;
